import { axios } from '@/services/axios';

const updateSSOProvider = async (provider) => {
    const res = await axios.put('/sso/provider', provider);
    return res.data;
};

export default updateSSOProvider;
